import React from "react";
import { useTranslation } from "react-i18next";

export default function ZoomModeNextButton(props) {
  const { t } = useTranslation();
  return (

    <li onClick={!props.disabled? props.onClick : undefined}>
      <span
      disabled={props.disabled}
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        }  ${ props.hideButton ? "passive" : "" } ${
          props.activeButton === "select" ? "active" : ""
        }`}
        title={t("Go to Next Presentation") + "->"}
        data-tip={t("Go to Next Presentation") + " ->"}
      >
        <img
          src={require("../../assets/img/svg/tools-zoom-mode-next.svg")}
          alt={t("Go to Next Presentation") + "->"}
        />
         {props.shouldShowButtonLabels && <span className="show-label-text">{t("Next")}</span>}
      </span>
    </li>
  );
}
